/* Built In Imports */
/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Services */

/**
 * Renders the SectionTitle component.
 *
 * @param titleObj.titleObj
 * @param {object} titleObj component.
 * @param {object} rest some more data
 * @param titleObj.section
 * @param titleObj.loadInit
 * @returns {ReactElement} UymSectionTitle component.
 */
export default function UymSectionTitle({
  titleObj,
  lang,
  titlecolor,
  loadInit,
  ...props
}) {
  const maxW = {
    'no-decoration': '770px',
  };
  return (
    <>
      {(titleObj?.titleText || titleObj?.title) && (
        <Box
          className={`title-${titleObj?.titleDecoration || 'default'}`}
          maxW={props.w || maxW[titleObj?.titleDecoration || '']}
          mx="auto"
          fontFamily={'MuktaMlalar'}
          fontSize={{ base: '26px', md: '34px' }}
          lineHeight={{ base: '32px', md: '53px' }}
          color={titlecolor ? titlecolor : '#02026B'}
          textAlign="center"
          mt={{ base: props.mt || '30px', md: props.mt || '30px' }}
          fontWeight={lang === 'ta' ? '600' : '500'}
        >
          <Box as="h2" pb={'15px'}>
            <Text fontSize={{ base: '26px', md: '34px' }}>
              {titleObj?.title || titleObj?.titleText}
            </Text>
          </Box>
          <Box
            textAlign="center"
            mb="15px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <LazyLoadImageComponent
              alt="divider"
              loading="lazy"
              title="divider"
              minHeight={'17px'}
              src={
                titlecolor
                  ? `${config.staticPath}/d/46272/1732966595-uyirnokam_kolamline_white.png`
                  : `${config.staticPath}/d/46272/1733145204-uyirnokam_kolamline_black.png`
              }
              width={{base:'200px', md:'275px'}}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
